import { useState, useEffect, createRef } from "react";
import {
  Grid,
  Button,
  Typography,
  Backdrop,
  CircularProgress,
  Box,
  Stepper,
  Step,
  StepLabel,
  Modal,
} from "@mui/material";
import Shell from "components/shell";
import { SubmitButton } from "components/buttons";
import { formatPhoneNumber, formatDate } from "utilities";
import classes from "./index.module.css";
import copy from "constants/copy";
import states from "constants/states";
import { isFormValid, Input, getFormValues } from "components/controls";
import { nameValidator } from "utilities";
import { useParams, useNavigate, Link } from "react-router-dom";
import {
  updateRegistration,
  updateDependentInvite,
  updateDependentEnrolment,
} from "../../data";
import { makeStyles } from "@mui/styles";
import { ErrorModal } from "components/errorModal";
import {
  SUBJECT_EMPLOYEE,
  SUBJECT_DEPENDENT,
  SPONSOR_HP,
  SPONSOR_CVS,
  NO_USER_FOUND,
  USER_NOT_EXIST_CODE,
  USER_EXIST_CODE_GENERAL_1,
  USER_EXIST_CODE_GENERAL_2,
  SUBJECT_PROVIDER,
  BOLD,
  USER_EXIST_CODE_CVS_1,
  USER_EXIST_CODE_CVS_2,
  USER_EXIST_CODE_CVS_3,
} from "../../constants/app";

const subjects = ["employee", "provider", "dependent"];

const steps = ["Welcome!", "Enrollment Information"];

const useStyles = makeStyles({
  root: {
    "& .css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root.Mui-completed": {
      color: "#174E8C",
    },
    "& .css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root.Mui-active": {
      color: "#174E8C",
    },
    "& .css-vnkopk-MuiStepLabel-iconContainer": {
      background: "white",
      borderRadius: "50%",
      padding: "5px",
    },
    "& .css-4ff9q7.Mui-active": {
      color: "#174E8C !important",
    },
    "& .css-a5nipc.MuiStepLabel-alternativeLabel": {
      background: "white !important",
      borderRadius: "50% !important",
      padding: "5px !important",
    },
    "& .css-4ff9q7.Mui-completed": {
      color: "#174E8C !important",
    },
    "& .css-zpcwqm-MuiStepConnector-root": {
      top: "15px !important",
    },
  },
});

const Register = () => {
  const styles = useStyles();
  let [subject, setSubject] = useState(useParams().subject);
  const [registrationValues, updateRegistrationValues] = useState({});
  const [errors, updateErrors] = useState([]);
  const [dependentEmails, updateDependentEmails] = useState([]);
  const [submitable, updateSubmitable] = useState(false);
  const [loading, updateLoading] = useState(false);
  const [credentialsErros, setCredentialsErros] = useState();
  const [open, setOpen] = useState({
    open: false,
    target: null,
    message: null,
    code:null
  });
  const handleOpen = (data, message,code) =>
    setOpen({ open: true, target: data, message: message,code:code });
  const handleClose = () => setOpen({ open: false });
  const formRef = createRef();
  let { code } = useParams();
  let sponsor = useParams().sponsor.toUpperCase();
  const navigate = useNavigate();

  // if(!subjects.includes(subject)) subject = subjects[0];

  const messages = {
    title: copy(`enrollment.title.${subject}`, ["BOLD Capital Partners"]),
    subtitle: copy(`enrollment.subtitle.${subject}`),
    stepper: copy(`enrollment.stepper.${subject}`),
    formTitle: copy(`enrollment.form.title.${subject}`),
    formSubtitle: copy(`enrollment.form.subtitle.${subject}`, null, ""),
    allFieldsRequired: copy(`enrollment.form.allFieldsRequired.${subject}`),
    firstNameLabel: copy(`enrollment.form.firstName.${subject}`),
    lastNameLabel: copy(`enrollment.form.lastName.${subject}`),
    dateOfBirthLabel: copy(`enrollment.form.dateOfBirth.${subject}`),
    emailLabel: copy(`enrollment.form.email.${subject}`),
    dependentEmailLabel: copy(`enrollment.form.dependentEmail.${subject}`, "1"),
    phoneLabel: copy(`enrollment.form.phone.${subject}`),
    stateLabel: copy(`enrollment.form.state.${subject}`),
    consent: copy(`enrollment.form.consent.${subject}`),
    marketing: copy(`enrollment.form.marketing.${subject}`),
    atrial: copy(`enrollment.form.atrial.${subject}`),
    hypertension: copy(`enrollment.form.hypertension.${subject}`),
    dependentButton: copy(`enrollment.dependentButton.${subject}`),
    submitButton: copy(`enrollment.form.submitButton.${subject}`),
    enrollButton: copy(`enrollment.form.enrollButton.${subject}`),
    eligibilityTitle: copy(`enrollment.eligibility.title.${subject}`),
    diseaseTitle: copy(`enrollment.eligibility.diseaseTitle.${subject}`),
    diseaseDescription: copy(
      `enrollment.eligibility.diseaseDescription.${subject}`
    ),
    failureTitle: copy(`enrollment.eligibility.failureTitle.${subject}`),
    failureDescription: copy(
      `enrollment.eligibility.failureDescription.${subject}`
    ),
    surgeryTitle: copy(`enrollment.eligibility.surgeryTitle.${subject}`),
    surgeryDescription: copy(
      `enrollment.eligibility.surgeryDescription.${subject}`
    ),
    restrictionTitle: copy(
      `enrollment.eligibility.restrictionTitle.${subject}`
    ),
    restrictionDescription: copy(
      `enrollment.eligibility.restrictionDescription.${subject}`
    ),
    dialysisTitle: copy(`enrollment.eligibility.dialysisTitle.${subject}`),
    dialysisDescription: copy(
      `enrollment.eligibility.dialysisDescription.${subject}`
    ),
  };

  const [isDuplicateFlag, setIsDuplicateFlag] = useState(false);
  let isDuplicate = [];
  let formValues = [];

  const handleRegistrationChange = (e) => {
    const target = e.target;
    let newValue = target.value;
    const name = target.name;

    if (name === "phoneNumber") newValue = formatPhoneNumber(newValue);
    else if (name === "dateOfBirth" || name === "employeeDateOfBirth")
      newValue = formatDate(newValue);
    else if (name === "firstName" || name === "enroleeFirstName")
      newValue = nameValidator(newValue);
    else if (name === "lastName" || name === "enroleeLastName")
      newValue = nameValidator(newValue);
    if (target.type === "checkbox") newValue = target.checked;

    updateRegistrationValues({ ...registrationValues, [name]: newValue });
    formValues = [{ ...registrationValues, [name]: newValue }];

    for (let i = 1; i <= dependentEmails.length; i++) {
      if (
        name.includes("dependentEmail") &&
        formValues[0][`dependentEmail${i}`] === formValues[0]["email"]
      ) {
        isDuplicate.push(formValues[0][`dependentEmail${i}`]);
      }
      if (
        name.includes("dependentEmail") &&
        (formValues[0][`dependentEmail${i}`] ===
          formValues[0][`dependentEmail${i + 1}`] ||
          registrationValues[`dependentEmail${i}`] === newValue)
      ) {
        isDuplicate.push(formValues[0][`dependentEmail${i}`]);
      }
    }
    isDuplicate?.length > 0
      ? setIsDuplicateFlag(true)
      : setIsDuplicateFlag(false);

    updateSubmitable(
      subject === SUBJECT_PROVIDER
        ? isFormValid(formRef.current) && isDuplicate?.length === 0
        : isFormValid(formRef.current)
    );
    updateErrors([]);
  };
  const fieldConfigs = {
    employeeFirstName: {
      type: "text",
      label: `${
        sponsor === SPONSOR_HP && subject === SUBJECT_DEPENDENT && "Employee"
      } ${messages.firstNameLabel}`,
      value: registrationValues.employeeFirstName,
      name: "employeeFirstName",
      onChange: handleRegistrationChange,
      validation: ["string"],
    },
    employeeLastName: {
      type: "text",
      label: `${
        sponsor === SPONSOR_HP && subject === SUBJECT_DEPENDENT && "Employee"
      } ${messages.lastNameLabel}`,
      value: registrationValues.employeeLastName,
      name: "employeeLastName",
      onChange: handleRegistrationChange,
      validation: ["string"],
    },
    employeeDateOfBirth: {
      type: "text",
      label: `${
        sponsor === SPONSOR_HP && subject === SUBJECT_DEPENDENT && "Employee"
      } ${messages.dateOfBirthLabel}`,
      value: registrationValues.employeeDateOfBirth,
      name: "employeeDateOfBirth",
      onChange: handleRegistrationChange,
      placeholder: "mm/dd/yyyy",
      validation: ["date"],
    },
    firstName: {
      type: "text",
      label: messages.firstNameLabel,
      value: registrationValues.firstName,
      name: "firstName",
      onChange: handleRegistrationChange,
      validation: ["string"],
      // validation:
      //   sponsor === BOLD
      //     ? subject === SUBJECT_PROVIDER
      //       ? ["isBoldDependentLastName"]
      //       : ["isBoldEmployeeLastName"]
      //     : ["string"],
      credentialValidation: credentialsErros?.first_name_mismatch,
    },
    lastName: {
      type: "text",
      label: messages.lastNameLabel,
      value: registrationValues.lastName,
      name: "lastName",
      onChange: handleRegistrationChange,
      validation: ["string"],
      // validation:
      //   sponsor === BOLD
      //     ? subject === SUBJECT_PROVIDER
      //       ? ["isBoldDependentLastName"]
      //       : ["isBoldEmployeeLastName"]
      //     : ["string"],
      credentialValidation: credentialsErros?.last_name_mismatch,
    },
    dateOfBirth: {
      type: "text",
      label: messages.dateOfBirthLabel,
      value: registrationValues.dateOfBirth,
      name: "dateOfBirth",
      onChange: handleRegistrationChange,
      placeholder: "mm/dd/yyyy",
      validation: ["date"],
      credentialValidation: credentialsErros?.dob_mismatch,
    },
    email: {
      type: "email",
      label: messages.emailLabel,
      value: registrationValues.email,
      name: "email",
      onChange: handleRegistrationChange,
      validation: ["email"],
    },
    phone: {
      type: "text",
      label: messages.phoneLabel,
      value: registrationValues.phoneNumber,
      name: "phoneNumber",
      onChange: handleRegistrationChange,
      validation: ["phone"],
    },
    state: {
      type: "select",
      label: messages.stateLabel,
      value: registrationValues.state,
      name: "state",
      onChange: handleRegistrationChange,
      validation: ["selected"],
    },
    consent: {
      type: "checkbox",
      label: messages.consent,
      value: registrationValues.consent,
      name: "consentTosPp",
      onChange: handleRegistrationChange,
      validation: ["checked"],
    },
    marketing: {
      type: "checkbox",
      label: messages.marketing,
      value: registrationValues.marketing,
      name: "consentMarketing",
      onChange: handleRegistrationChange,
    },
    atrial: {
      type: "checkbox",
      label: messages.atrial,
      value: registrationValues.atrial,
      name: "atrialFibrillation",
      onChange: handleRegistrationChange,
    },
    hypertension: {
      type: "checkbox",
      label: messages.hypertension,
      value: registrationValues.hypertension,
      name: "hypertensionBox",
      onChange: handleRegistrationChange,
    },
  };
  if (sponsor === SPONSOR_CVS) {
    fieldConfigs["atrial"]["validation"] = ["atrial"];
  }
  const [canAddMoreDependent, setCanAddMoreDependent] = useState(true);
  const addDependentEmail = () => {
    const emails = dependentEmails.slice();
    const index = dependentEmails.length + 1;
    const emailConfig = {
      label: copy(`enrollment.form.dependentEmail.${subject}`, [index]),
      name: `dependentEmail${index}`,
      type: "email",
      index,
      validation: ["email"],
    };
    emails.push(emailConfig);
    if (emails.length > 2) {
      setCanAddMoreDependent(false);
    }
    updateDependentEmails(emails);
    updateSubmitable(isFormValid(formRef.current));
  };

  const removeDependentEmail = function (i) {
    const emails = dependentEmails.slice();
    // emails.splice(i, 1);
    emails.pop();
    if (emails.length < 3) {
      setCanAddMoreDependent(true);
    }
    updateDependentEmails(emails);
  };
  const getUpdatedformValue = (formValues) => {
    let programType = `${formValues?.atrialFibrillation}-${formValues?.hypertensionBox}`;
    const object = {
      "false-false": "Hypertension-Id",
      "true-false": "Afib-Id",
      "false-true": "Hypertension-Id",
      "true-true": "AfibAndHypertension-Id",
    };
    formValues["programId"] = object[programType];
    formValues["sponsorSymbol"] = formValues.sponsorSymbol.toUpperCase();
    delete formValues.hypertensionBox;
    delete formValues.atrialFibrillation;
    return formValues;
  };
  const getError = (errors) => {
    let errorObj = {
      first_name_mismatch: null,
      dob_mismatch: null,
      last_name_mismatch: null,
    };
    for (let i = 0; i < errors.length; i++) {
      let code = errors[i]?.code;
      let errorDetail = errors[i]?.detail;
      if (code in errorObj) {
        errorObj[code] = errors[i]?.detail;
      } else if (
        errorDetail === NO_USER_FOUND ||
        code === USER_NOT_EXIST_CODE
      ) {
        handleOpen(SPONSOR_CVS, "You are not eligible user.",code);
      } else if (code === USER_EXIST_CODE_CVS_1 || code === USER_EXIST_CODE_CVS_2  || code === USER_EXIST_CODE_CVS_3) {
        handleOpen(SPONSOR_CVS, "This email is already in use in the Kardia app",code);
      }else if(code === USER_EXIST_CODE_GENERAL_1 || code === USER_EXIST_CODE_GENERAL_2){
        handleOpen(SPONSOR_CVS, "You've already enrolled in KardiaComplete",code);
      }
    }
    setCredentialsErros(errorObj);
  };

  useEffect(() => {
    updateRegistrationValues({});
  }, [subject]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isFormValid(e.target)) {
      const formValues = getFormValues(e.target);
      formValues.sponsorSymbol = formValues.sponsorSymbol.toUpperCase();
      let resp;
      let updatedFormValue;
      updateLoading(true);
      if (subject === SUBJECT_PROVIDER) {
        resp = await updateDependentInvite(formValues);
        if (resp.errors) handleOpen(BOLD, resp.errors[0].title,resp.errors[0]?.code);
      } else if (
        subject === SUBJECT_EMPLOYEE ||
        (subject === SUBJECT_DEPENDENT && sponsor !== BOLD)
      ) {
        updatedFormValue = getUpdatedformValue(formValues);
        resp = await updateRegistration(updatedFormValue);
        if (resp?.errors) {
          // if (sponsor === SPONSOR_CVS) {
          //   console.log(resp?.errors);
            getError(resp?.errors);
          // } else handleOpen(SPONSOR_HP);
        }
      } else {
        updatedFormValue = getUpdatedformValue(formValues);
        resp = await updateDependentEnrolment(
          updatedFormValue,
          sponsor === BOLD
        );
        if (resp?.status !== 200) {
          updateLoading(false);
          handleOpen(SPONSOR_HP);
        }
        resp = await resp.json();
      }
      if (resp.errors) updateErrors(resp.errors);
      else navigate(`/confirmation/${sponsor}/${subject}`);
      updateLoading(false);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    sponsor === SPONSOR_CVS &&
      subject === SUBJECT_DEPENDENT &&
      navigate(`/enroll/${SPONSOR_CVS}/${SUBJECT_EMPLOYEE}`);
    subject === SUBJECT_PROVIDER && addDependentEmail();
  }, []);
  useEffect(
    () => updateSubmitable(isFormValid(formRef.current)),
    [dependentEmails]
  );
  const checkSubmit = () => {
    let check =
      registrationValues?.atrialFibrillation === true ||
      registrationValues?.hypertensionBox === true;
    return check;
  };
  const getEnrollInfo = () => {
    return (
      <>
        <Grid item xs={6} className={classes["form-row"]}>
          <Input {...fieldConfigs.firstName} />
        </Grid>
        <Grid item xs={6} className={classes["form-row"]}>
          <Input {...fieldConfigs.lastName} />
        </Grid>
        <Grid item xs={12} className={classes["form-row"]}>
          <Input {...fieldConfigs.dateOfBirth} />
        </Grid>
      </>
    );
  };
  const getEmployeeInfo = () => {
    return (
      <>
        <Grid item xs={6} className={classes["form-row"]}>
          <Input {...fieldConfigs.employeeFirstName} />
        </Grid>
        <Grid item xs={6} className={classes["form-row"]}>
          <Input {...fieldConfigs.employeeLastName} />
        </Grid>
        <Grid item xs={12} className={classes["form-row"]}>
          <Input {...fieldConfigs.employeeDateOfBirth} />
        </Grid>
      </>
    );
  };
  return (
    <Shell>
      <Grid container className={classes["gridContainer"]}>
        <Grid item xs={2}></Grid>
        <Grid item xs={8} className={classes.titles}>
          {(sponsor === SPONSOR_HP || sponsor === BOLD) && (
            <Box sx={{ width: "100%" }}>
              <Stepper
                activeStep={1}
                alternativeLabel
                className={`${classes["stepperStyle"]} ${styles.root}`}
              >
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel className={classes["textStyle"]}>
                      <Typography
                        variant="subtitle1"
                        style={{
                          paddingTop: label === "Welcome!" && 9,
                          fontSize: 18,
                          fontFamily: "'DM Sans', sans-serif",
                          fontWeight: 600,
                          lineHeight: "inherit",
                        }}
                      >
                        {label === "Welcome!" ? label : messages.stepper}
                      </Typography>
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
          )}
          <div
            className={
              sponsor === SPONSOR_HP || sponsor === BOLD
                ? classes["titleEnrollText"]
                : classes["cvsTitleEnrolltext"]
            }
          >
            <Typography
              variant="h4"
              style={{
                color: "#182C3D",
                marginBottom: "8px",
                fontSize: 36,
                fontFamily: "'DM Sans', sans-serif",
              }}
            >
              {messages.title}
            </Typography>
            <Typography variant="subtitle1" className={classes["subheadline"]}>
              {messages.subtitle}
            </Typography>
          </div>
          {sponsor === SPONSOR_HP &&
            (subject === SUBJECT_DEPENDENT || subject === SUBJECT_EMPLOYEE) && (
              <Typography variant="subtitle1" className={classes["enrollLink"]}>
                Are you enrolling as an{" "}
                {subject === SUBJECT_EMPLOYEE
                  ? SUBJECT_DEPENDENT
                  : SUBJECT_EMPLOYEE}
                ?{" "}
                <Link
                  onClick={() =>
                    setSubject(
                      subject === SUBJECT_EMPLOYEE
                        ? SUBJECT_DEPENDENT
                        : SUBJECT_EMPLOYEE
                    )
                  }
                  to={`/enroll/${sponsor}/${
                    subject === SUBJECT_EMPLOYEE
                      ? SUBJECT_DEPENDENT
                      : SUBJECT_EMPLOYEE
                  }`}
                  className={classes["aLink"]}
                >
                  Click here.
                </Link>
              </Typography>
            )}
        </Grid>
        <Grid item xs={2}></Grid>
        {/* <Grid item xs={2} md = {2} lg = {2}></Grid> */}
        <Grid
          sm={8}
          md={8}
          lg={8}
          container
          order={{ xs: 2, md: 1 }}
          className={classes["backdrop-container"]}
        >
          <Backdrop open={loading} className={classes.backdrop}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <form
            onSubmit={handleSubmit}
            className={classes["registration-form"]}
            ref={formRef}
          >
            <input
              type="hidden"
              name="sponsorSymbol"
              value={sponsor}
              data-valid="true"
            />
            {subject === SUBJECT_DEPENDENT && (
              <input type="hidden" name="id" value={code} data-valid="true" />
            )}
            <Typography
              variant="h3"
              className={classes["registration-headline"]}
            >
              {messages.formTitle}{" "}
              <span className={classes["all-fields-required"]}>
                {messages.allFieldsRequired}
              </span>
            </Typography>
            <Typography
              variant="subtitle2"
              style={{
                fontSize: 17,
                fontFamily: "'DM Sans', sans-serif",
                fontWeight: 400,
              }}
            >
              {sponsor === SPONSOR_HP
                ? "Please enter your information as it appears on your insurance card."
                : sponsor === SPONSOR_CVS
                ? "Please enter the required fields as they are written on your health insurance card."
                : ""}
            </Typography>
            {/* <div
              className={`${classes["registration-error-display"]} ${
                errors.length ? classes["registration-display-errors"] : ""
              }`}
            >
              {errors.map((error, arr, i) => (
                <Typography variant="h4" key={error.id}>
                  {error.title === "Error Dependent Does Not Exist" ? (
                    <>
                      Could not find your email in the system, please inform
                      employee to invite you
                    </>
                  ) : (
                    <>
                      Invalid user information. Please verify that you’ve
                      entered the correct information.
                    </>
                  )}
                </Typography>
              ))}
            </div> */}
            <Typography
              variant="p"
              className={classes["registration-subtitle"]}
            >
              {messages.formSubtitle}
            </Typography>
            {sponsor === SPONSOR_HP && subject === SUBJECT_DEPENDENT && (
              <Grid container spacing={1} className={classes["form-fields"]}>
                <Grid item xs={12}>
                  <Typography
                    variant="h4"
                    className={classes["registration-headline"]}
                    style={{ fontSize: 21 }}
                  >
                    Employee Information
                  </Typography>
                </Grid>
                {getEmployeeInfo()}
              </Grid>
            )}
            {(subject === SUBJECT_EMPLOYEE ||
              subject === SUBJECT_DEPENDENT) && (
              <Grid container spacing={1} className={classes["form-fields"]}>
                {sponsor === SPONSOR_HP && subject === SUBJECT_DEPENDENT && (
                  <Grid item xs={12}>
                    <Typography
                      variant="h4"
                      className={classes["registration-headline"]}
                      style={{ fontSize: 21 }}
                    >
                      Enrollee Information
                    </Typography>
                  </Grid>
                )}

                {getEnrollInfo()}
                <Grid item xs={12} className={classes["form-row"]}>
                  <Input {...fieldConfigs.email} />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    style={{
                      fontWeight: "bold",
                      fontSize: 17,
                      fontFamily: "'DM Sans', sans-serif",
                      marginTop:25
                    }}
                  >
                    {sponsor === SPONSOR_CVS &&
                    registrationValues?.atrialFibrillation !== false
                      ? "Please select the statement(s) below that apply to you. To be eligible for KardiaComplete, you should have received an Atrial Fibrillation diagnosis."
                      : `If applicable, please select the statement(s) below that apply to you: `}
                    {(sponsor === SPONSOR_CVS || sponsor === SPONSOR_HP) && (
                      <span className={classes.asterikStyle}> *</span>
                    )}
                  </Typography>
                  {sponsor === SPONSOR_CVS &&
                    registrationValues?.atrialFibrillation === false && (
                      <div className={classes.errorLine}>
                        This is required field.
                      </div>
                    )}
                  {sponsor === SPONSOR_HP &&
                    ((registrationValues?.atrialFibrillation === false &&
                      registrationValues?.hypertensionBox === undefined) ||
                      (registrationValues?.atrialFibrillation === undefined &&
                        registrationValues?.hypertensionBox === false) ||
                      (registrationValues?.atrialFibrillation === false &&
                        registrationValues?.hypertensionBox === false)) && (
                      <div className={classes.errorLine}>
                        This is required field.
                      </div>
                    )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  className={`${classes["form-consent"]} ${classes["atrialHypertensionStyle"]}`}
                >
                  <Input {...fieldConfigs.atrial} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  className={`${classes["form-consent"]} ${classes["atrialHypertensionStyle"]}`}
                >
                  <Input {...fieldConfigs.hypertension} />
                </Grid>
                <Grid item xs={12} className={classes["form-consent"]}>
                  <Input {...fieldConfigs.consent} />
                </Grid>
                <Grid item xs={12} className={classes["form-consent"]}>
                  <Input {...fieldConfigs.marketing} />
                </Grid>
              </Grid>
            )}
            {subject === "provider" && (
              <>
                <Grid container spacing={1} className={classes["form-fields"]}>
                  <Grid item xs={6} className={classes["form-row"]}>
                    <Input {...fieldConfigs.firstName} />
                  </Grid>
                  <Grid item xs={6} className={classes["form-row"]}>
                    <Input {...fieldConfigs.lastName} />
                  </Grid>
                  <Grid item xs={12} className={classes["form-row"]}>
                    <Input {...fieldConfigs.email} />
                  </Grid>
                  {dependentEmails.map((email) => {
                    const config = {
                      ...email,
                      value:
                        registrationValues[`dependentEmail${email.index}`] ||
                        "",
                      onChange: handleRegistrationChange,
                      remove:
                        email.index > 1
                          ? removeDependentEmail.bind(null, email.index - 1)
                          : null,
                    };
                    return (
                      <Grid
                        item
                        xs={12}
                        className={classes["form-row"]}
                        key={email.index}
                      >
                        <Input {...config} />
                      </Grid>
                    );
                  })}
                </Grid>
                <Grid
                  item
                  xs={12}
                  className={classes["add-dependent-container"]}
                >
                  {isDuplicateFlag && (
                    <span
                      style={{
                        color: "rgb(204, 61, 63)",
                        fontSize: 14,
                        fontWeight: 700,
                        fontFamily: "DM Sans, sans-serif",
                      }}
                    >
                      duplicate dependent email
                    </span>
                  )}
                  <Button
                    disabled={!canAddMoreDependent}
                    variant="outlined"
                    className={classes["invite-outline-button"]}
                    fullWidth={true}
                    onClick={addDependentEmail}
                  >
                    {messages.dependentButton}
                  </Button>
                </Grid>
              </>
            )}
            <Grid item xs={12} className={classes["submit-button-container"]}>
              <SubmitButton
                text={
                  subject === "provider"
                    ? messages.submitButton
                    : messages.enrollButton
                }
                fullWidth={true}
                disabled={
                  sponsor === SPONSOR_HP
                    ? !checkSubmit() || !submitable
                    : !submitable || loading
                }
              />
            </Grid>
          </form>
        </Grid>
        <Grid item xs={2} md={2} lg={2}></Grid>
        {/* <Grid item md={6} xs={12} order={{ xs: 1, md: 2 }}>
          <div className={classes.eligibility}>
            <Typography variant="p" className={classes["eligibility-intro"]}>
              {messages.eligibilityTitle}:
            </Typography>
            <Typography
              variant="h4"
              className={classes["eligibility-headline"]}
            >
              {messages.diseaseTitle}
            </Typography>
            <Typography variant="p" className={classes["eligibility-label"]}>
              {messages.diseaseDescription}
            </Typography>
            <Typography
              variant="h4"
              className={classes["eligibility-headline"]}
            >
              {messages.failureTitle}
            </Typography>
            <Typography variant="p" className={classes["eligibility-label"]}>
              {messages.failureDescription}
            </Typography>
            <Typography
              variant="h4"
              className={classes["eligibility-headline"]}
            >
              {messages.surgeryTitle}
            </Typography>
            <Typography variant="p" className={classes["eligibility-label"]}>
              {messages.surgeryDescription}
            </Typography>
            <Typography
              variant="h4"
              className={classes["eligibility-headline"]}
            >
              {messages.restrictionTitle}
            </Typography>
            <Typography variant="p" className={classes["eligibility-label"]}>
              {messages.restrictionDescription}
            </Typography>
            <Typography
              variant="h4"
              className={classes["eligibility-headline"]}
            >
              {messages.dialysisTitle}
            </Typography>
            <Typography variant="p" className={classes["eligibility-label"]}>
              {messages.dialysisDescription}
            </Typography>
          </div>
        </Grid> */}
      </Grid>
      <div>
        {/* <Button onClick={handleOpen}>Open modal</Button> */}
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open.open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <ErrorModal
            handleClose={handleClose}
            open={open.open}
            target={open.target}
            message={open.message}
            code = {open.code}
          />
        </Modal>
      </div>
    </Shell>
  );
};

export default Register;
